import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  PositionMemberConflict,
  ReassignMemberWarningDialogData,
  ReassignMemberWarningDialogResult,
} from '@core/tellent-positions-types';
import { resolveMemberFullName } from '@core/tellent-util';
import {
  AvatarComponent,
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-reassign-member-warning-dialog',
  templateUrl: './reassign-member-warning-dialog.component.html',
  styleUrls: ['./reassign-member-warning-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    TranslatePipe,
  ],
})
export class ReassignMemberWarningDialogComponent implements DialogComponentI<
  ReassignMemberWarningDialogData,
  ReassignMemberWarningDialogResult
> {
  private readonly dialogRef = inject(DialogRef);
  private readonly members = signal<PositionMemberConflict[]>([]);

  public targetPositionName = signal<string>('');

  public membersWithFullNames = computed(() =>
    this.members().map(({ member, currentPosition }) => ({
      member,
      currentPosition,
      fullName: resolveMemberFullName(member),
    })),
  );

  public setDialogData(data: ReassignMemberWarningDialogData, triggerUpdate: boolean): void {
    this.targetPositionName.set(data.targetPositionName);
    this.members.set(data.members);
  }

  public cancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  public confirm(): void {
    this.dialogRef.close({ confirmed: true });
  }
}
